import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Progress } from 'semantic-ui-react';

import {
  InputFile,
  InsertError,
  UploadButton,
  UploadVideoContent,
} from './styles';

import {
  uploadVideo,
} from '../../utils/upload-video';

const VIDEO_PERCENT_THRESHOLD = 98;

const UploadVideo = ({ sessionId, onUploadCompleted, replace = false }) => {
  const fileInput = React.createRef();

  const [percent, setPercent] = useState(0);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  return (
    <UploadVideoContent>
      <InputFile
        type="file"
        placeholder="Choose video file"
        ref={fileInput}
      />

      <UploadButton
        loading={loading}
        onClick={() => {
          const videoFile = _.get(fileInput, 'current.inputRef', { files: [] }).files[0];

          if (!videoFile) {
            return;
          }

          setLoading(true);

          uploadVideo(sessionId, videoFile,
            // onProgress
            (progress) => {
              setPercent(progress < VIDEO_PERCENT_THRESHOLD ? progress : VIDEO_PERCENT_THRESHOLD);
            },
            // onCompleted
            (response) => {
              setPercent(100);
              setLoading(false);
              onUploadCompleted({
                variables: {
                  testSessionId: sessionId,
                  videoUrl: response.location,
                },
              });
              setError(null);
            },
            // onError
            (err) => {
              setError(err);
              setLoading(false);
            }, replace);
        }}
      >
        Upload
      </UploadButton>

      {percent ? <Progress percent={percent} indicating /> : null}

      {error && <InsertError>Error while uploading video</InsertError>}
    </UploadVideoContent>
  );
};

UploadVideo.propTypes = {
  sessionId: PropTypes.string.isRequired,
  onUploadCompleted: PropTypes.func.isRequired,
  replace: PropTypes.bool,
};

UploadVideo.defaultProps = {
  replace: false,
};

export default UploadVideo;
